import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  radio: {
    id: 't.radio',
    defaultMessage: '{name} Radio',
  },
  topSongs: {
    id: 't.topSongs',
    defaultMessage: 'Top Songs',
  },
});
